export const data = [
  {
    id: 1,
    title: "Is there any cost or obligation if l request an offer?",
    text: "I see Coint being a long-term part of my  business structure. Not just for this business, but also our future endeavors. ",
  },
  {
    id: 2,
    title: "What kind of construction services will be purchased?",
    text: "I see Coint being a long-term part of my  business structure. Not just for this business, but also our future endeavors.",
  },
  {
    id: 3,
    title: "How Do I Print My Auto Insurance ID Card?",
    text: "I see Coint being a long-term part of my  business structure. Not just for this business, but also our future endeavors.",
  },
  {
    id: 4,
    title: "How Do I Know What Deductible Applies To My Policy?",
    text: "I see Coint being a long-term part of my  business structure. Not just for this business, but also our future endeavors.",
  },
  {
    id: 5,
    title: "If I Am Moving, Will I Need To Request A New Agent?",
    text: "I see Coint being a long-term part of my  business structure. Not just for this business, but also our future endeavors.",
  },
];
